interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /**
   * Data attributes to apply to the toggle element
   * @example { 'data-intercom-target': 'my-toggle', 'data-testid': 'settings-toggle' }
   */
  dataAttributes?: Record<string, string>;
  disabled?: boolean;
  /**
   * Accessible label for screen readers
   */
  ariaLabel?: string;
}

function ToggleSwitch({
  checked,
  onChange,
  dataAttributes,
  disabled = false,
  ariaLabel,
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      className="relative inline-block focus:outline-none focus:ring-2 focus:ring-teal-300 focus:ring-offset-2 rounded-full border-0 bg-transparent p-0"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      {...dataAttributes}
    >
      <div
        className={`block w-14 h-8 rounded-full transition-colors pointer-events-none ${
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        } ${checked ? 'bg-teal-600' : 'bg-gray-700'}`}
      />
      <div
        className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform pointer-events-none ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        } ${checked ? 'translate-x-6' : ''}`}
      />
    </button>
  );
}

export default ToggleSwitch;
